import {
  CategoryFilter,
  CategoryKey,
  categoryOrder,
  CreateExperimentDialogRenderLocation,
  ExperienceCreationCard,
  TestAction,
} from "@src/components/Dialogs/CreateExperienceDialog/types";
import { EXPERIMENT_ROUTES } from "@src/routes/routes";
import { TabEnumFe } from "@intelligems/ig-types";
import { experienceCreationCards } from "@src/components/Dialogs/CreateExperienceDialog/CreateExperienceDialog";

export const hasCardForCategory = (
  category: CategoryKey,
  cards: ExperienceCreationCard[]
) => cards.some((card) => card.category === category);

export const getInitialActiveCategory = (
  renderLocation: CreateExperimentDialogRenderLocation,
  showContentSection: boolean | undefined
): CategoryFilter => {
  if (showContentSection) {
    return "content";
  }

  return categoryOrder.includes(renderLocation as CategoryKey)
    ? (renderLocation as CategoryKey)
    : "all";
};

export const getAvailableCategory = (
  category: CategoryFilter,
  cards: ExperienceCreationCard[]
): CategoryFilter => {
  if (category === "all" || hasCardForCategory(category, cards)) {
    return category;
  }

  return "all";
};

export const getTestLink = (test: TestAction) =>
  `${EXPERIMENT_ROUTES.Experiment}/?action=new&type=${test.experienceType}&tab=${TabEnumFe.TEST_GROUPS}`;

/**
 * Default experience name, dated so a merchant can tell two same-day drafts
 * apart. Split out from `getGeneratedTestName` so callers that have no card to
 * name themselves after — the AI intake routes offers straight to a route
 * rather than through `experienceCreationCards` — share one format.
 */
export const getGeneratedNameForTitle = (title: string) => {
  const date = new Date();
  const month = date.toLocaleString("default", { month: "short" });
  return `${title} · ${month} ${date.getDate()}`;
};

export const getGeneratedTestName = (card: ExperienceCreationCard) =>
  getGeneratedNameForTitle(`${card.title} Test`);

export const getDialogSource = (
  renderLocation: CreateExperimentDialogRenderLocation
) => (renderLocation === "homeDashboard" ? "home_page" : "test_page");

export const getVisibleCards = (filterKeys: string[]) =>
  experienceCreationCards.filter((card) => {
    const matchesFilter =
      filterKeys.length === 0 ||
      card.filterKeys.some((key) => filterKeys.includes(key));

    return matchesFilter;
  });
